import { RootState } from '@store/store'
import { createSelector } from 'reselect'

export const selectAuthor = (state: RootState) => state.author

export const selectAuthorsLoading = createSelector(
  [selectAuthor],
  (authors) => authors.loading
)
export const selectAllAuthors = createSelector(
  [selectAuthor],
  (authors) => authors.authorList
)

export const selectAuthorByEmail = createSelector(
  [selectAuthor, (_: RootState, email: string) => email],
  (authors, email) =>
    authors.authorList.find((author) => author.email === email)
)
